module.exports = __webpack_public_path__ + "img/593.6253e3f3.jpg";